import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { NavBar, Icon, ListView, Card, WingBlank, WhiteSpace, List, Button, Modal, InputItem, Toast, Badge, ActionSheet } from 'antd-mobile';
import TipPlaceholder from '../components/TipPlaceholder';
import LoadingPlaceholder from '../components/LoadingPlaceholder';
import DataFetcher from '../utils/DataFetcher';
import { createForm } from 'rc-form';
import Constants from '../utils/Constants';
import '../styles/AgentCouponOrganization.css';

const history = require("history").createHashHistory()
const alert = Modal.alert

class AgentCouponOrganization extends Component {
    constructor(props) {
        super(props);

        let dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });

        this.state = {
            dataSource,
            isLoading: true,
            hasMore: true,
            height: document.documentElement.clientHeight * 3 / 4,
            showCreateModal: false,
            enableCreate: true,
            showUpdateModal: false,
            enableUpdate: true,
            selectedItem: null,
        }
    }

    componentDidMount() {
        let height = document.documentElement.clientHeight - ReactDOM.findDOMNode(this.lv).parentNode.offsetTop - 65;
        this.setState({
            height
        })
        this.loadPageData(1)
    }

    loadPageData = (pageNum) => {
        DataFetcher.agentOrganizations({
            pageNum,
            pageSize: 10,
        }, {
            success: (resp) => {
                let data = resp.data
                this.pageNum = data.pageNum;
                this.pageSize = data.pageSize;
                this.pages = data.pages;
                let oldRowDatas = this.rowDatas&&pageNum>1 ? this.rowDatas : {}
                this.rowDatas = {...oldRowDatas, ...this.wrapIntoRowDatas(data.result)};
                this.setState({
                    dataSource: this.state.dataSource.cloneWithRows(this.rowDatas),
                    isLoading: false,
                    hasMore: this.pageNum < this.pages,
                })
            }
        })
    }

    onEndReached = (event) => {
        const { isLoading, hasMore } = this.state

        if (isLoading || !hasMore) {
            return;
        }

        this.setState({ isLoading: true });
        this.loadPageData(++this.pageNum)
    }

    handleItemClick = (rowData) => {
        const options = [
            { icon: <i className='iconfont icon-xiugai' style={{color:'#04bbc5', fontSize: 30}}/>, title: '编辑信息' },
            { icon: <i className='iconfont icon-group-chat' style={{color:'orange', fontSize: 30}}/>, title: '发券员' }
        ]
        if(rowData.status === 1) {
            options.push({ icon: <i className='iconfont icon-tingyong' style={{color:'red', fontSize: 40}}/>, title: '停用' })
        } else {
            options.push({ icon: <i className='iconfont icon-qiyong' style={{color:'green', fontSize: 40}}/>, title: '启用' })
        }
        
        let optionMap = {}
        for(let i = 0; i < options.length; i++) {
            optionMap[i] = options[i].title
        }
        ActionSheet.showShareActionSheetWithOptions({
            options,
            title: '操作',
            message: rowData.name,
        },
        (buttonIndex) => {
            let buttonTitle = optionMap[buttonIndex]
            if(!buttonTitle) return

            if(buttonTitle === '编辑信息') {
                this.setState({
                    showUpdateModal: true,
                    selectedItem: rowData
                })
            } else if(buttonTitle === '发券员') {
                history.push(`/agent/coupon_operator/${rowData.id}`)
            } else if(buttonTitle === '启用') {
                this.handleEnableClick(rowData)
            } else if(buttonTitle === '停用') {
                this.handleDisableClick(rowData)
            } else {
                Toast.info('功能开发中')
            }
        });
    }

    handleCreateClick = () => {
        if(!this.state.enableCreate) {
            return
        }

        this.setState({
            enableCreate: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('create_') !== 0) {
                        continue
                    }
                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableCreate: true
                        })
                        return
                    }
                }
            }

            const params = {}
            for(let prop in fieldsValue) {
                if(prop.indexOf('create_') !== 0) {
                    continue
                }
                params[prop.substring('create_'.length)] = fieldsValue[prop]                
            }

            DataFetcher.createOrganization(params, {
                success: (resp) => {
                    this.setState({
                        showCreateModal: false
                    })
                    this.props.form.resetFields()
                    this.loadPageData(1)
                },
                completed: () => {
                    this.setState({
                        enableCreate: true
                    })
                }
            })
        });
    }

    handleUpdateClick = () => {
        const { selectedItem } = this.state
        if(!selectedItem) return

        if(!this.state.enableUpdate) {
            return
        }

        this.setState({
            enableUpdate: false
        })
        this.props.form.validateFields((error, fieldsValue) => {
            if(error) {
                for(let prop in error) {
                    if(prop.indexOf('update_') !== 0) {
                        continue
                    }

                    let item = error[prop]
                    if(item.errors && item.errors.length) {
                        Toast.fail(item.errors[0].message)
                        this.setState({
                            enableUpdate: true
                        })
                        return
                    }
                }
            }

            const params = {
                id: selectedItem.id
            }
            for(let prop in fieldsValue) {
                if(prop.indexOf('update_') !== 0) {
                    continue
                }
                params[prop.substring('update_'.length)] = fieldsValue[prop]                
            }

            DataFetcher.updateOrganization(params, {
                success: (resp) => {
                    this.setState({
                        showUpdateModal: false
                    })
                    this.props.form.resetFields()
                    this.loadPageData(1)
                },
                completed: () => {
                    this.setState({
                        enableUpdate: true
                    })
                }
            })
        });
    }

    handleEnableClick = (rowData) => {
        alert('确认要启用发券商?', rowData.name, [
            { text: '取消', onPress: () => {} },
            { text: '确认', onPress: () => {
                DataFetcher.enableOrganization({
                    id: rowData.id
                }, {
                    success: (resp) => {
                        Toast.info('发券商已启用')
                        this.loadPageData(1)
                    }
                })
            }},
          ])
    }

    handleDisableClick = (rowData) => {
        alert('确认要停用发券商?', rowData.name, [
            { text: '取消', onPress: () => {} },
            { text: '确认', onPress: () => {
                DataFetcher.disableOrganization({
                    id: rowData.id
                }, {
                    success: (resp) => {
                        Toast.info('发券商已停用')
                        this.loadPageData(1)
                    }
                })
            }},
          ])
    }

    wrapIntoRowDatas(datas) {
        if (!datas||datas.length<=0) {
            return {};
        }

        let rowDatas = {};
        datas.forEach((data, index) => {
            let id = this.pageNum*this.pageSize + index
            rowDatas[id] = data;
        })
        return rowDatas;
    }

    renderFooter = (isLoading) => {
        if(isLoading) {
            return <LoadingPlaceholder/>
        }

        const { dataSource } = this.state
        if(dataSource.getRowCount()) {
            return <div></div>
        }

        return <TipPlaceholder firstTip='暂无数据'/>
    }

    renderSeparator(sectionId, rowId) {
        return <WhiteSpace key={rowId}/>
    }

    renderRow = (rowData, sectionId, rowId) => {
        let statusText = Constants.DICT_STATUS[rowData.status]
        let statusColor = rowData.status === 1 ? '#04bbc5' : 'gray'
        let tagBadge = (<Badge text={statusText} style={{backgroundColor: statusColor}}/>)
        return (
            <WingBlank size='sm'>
                <div onClick={() => {this.handleItemClick(rowData)}}>
                    <Card key={rowId}>
                        <Card.Header
                            title={<span className='word-ellipsis'>{rowData.name}</span>}
                            extra={tagBadge}
                        />
                        <Card.Body>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis'>
                                    <span className='label'>发券员：</span> 
                                    <span className='value'>{rowData.operatorCount}</span>
                                </div>
                            </div>
                            <div className='info-row'>
                                <div className='info-column word-ellipsis' style={{width: '100%'}}>
                                    <span className='label'>描&nbsp;&nbsp;&nbsp;述：</span> 
                                    <span className='value'>{rowData.description}</span>
                                </div>
                            </div>
                        </Card.Body>
                        <Card.Footer extra={<span className='word-ellipsis'>{rowData.createTime}</span>}/>
                    </Card>
                </div>
            </WingBlank>
        )
    }

    doRenderCreateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showCreateModal, enableCreate } = this.state

        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showCreateModal}
                    onClose={() => {
                        this.setState({showCreateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" style={{maxHeight: 500, overflow: 'scroll'}} renderHeader={() => <div className='modal-title'>新建发券商</div>}>
                        <InputItem {...getFieldProps('create_name', {})}>
                            名称
                        </InputItem>
                        <InputItem {...getFieldProps('create_description', {
                        })}>
                            描述
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleCreateClick} disabled={!enableCreate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    doRenderUpdateModal = () => {
        const { getFieldProps } = this.props.form;
        const { showUpdateModal, enableUpdate, selectedItem } = this.state
        
        return (
            <WingBlank>
                <Modal
                    popup
                    visible={showUpdateModal}
                    onClose={() => {
                        this.setState({showUpdateModal: false})
                        this.props.form.resetFields()
                    }}
                    animationType="slide-up"
                    afterClose={() => {}}
                >
                    <List className="popup-list" style={{maxHeight: 500}} renderHeader={() => <div className='modal-title'>编辑信息</div>}>
                        <InputItem {...getFieldProps('update_name', {
                            initialValue: selectedItem?selectedItem.name:null,
                        })}>
                            名称
                        </InputItem>
                        <InputItem {...getFieldProps('update_description', {
                            initialValue: selectedItem?selectedItem.description:null,
                        })}>
                            描述
                        </InputItem>
                        <List.Item>
                            <Button type="primary" onClick={this.handleUpdateClick} disabled={!enableUpdate}>提交</Button>
                        </List.Item>
                    </List>
                </Modal>
            </WingBlank>
        )
    }

    render() {
        const { dataSource, isLoading } = this.state;

        return (
            <div className='page-agent-coupon-organization'>
                <NavBar 
                    mode="light" 
                    icon={<Icon type="left" color="black" size="md"/>} 
                    onLeftClick={history.goBack}
                    rightContent={<i className='iconfont icon-tianjia' style={{color:'black'}} onClick={() => {this.setState({showCreateModal: true})}}></i>}
                >
                    发券商
                </NavBar>
                <ListView
                    ref={el => this.lv = el}
                    dataSource={dataSource}
                    renderFooter={() => this.renderFooter(isLoading)}
                    renderRow={this.renderRow}
                    renderSeparator={this.renderSeparator}
                    pageSize={8}
                    scrollRenderAheadDistance={500}
                    onEndReached={this.onEndReached}
                    onEndReachedThreshold={10}
                    style={{
                        height: this.state.height,
                        overflow: 'auto',
                        paddingTop: 50
                    }}
                />
                {this.doRenderCreateModal()}
                {this.doRenderUpdateModal()}
            </div>
        )
    }
}

export default createForm()(AgentCouponOrganization);


// WEBPACK FOOTER //
// ./src/modules/AgentCouponOrganization.js